'use client';
import Image from 'next/image';
import Link from 'next/link';

const pastEvents = [
  
  {
    href: 'https://luma.com/kolconnectabudhabi',
    src: '/images/kol-luma-event-abu-dhabi.webp',
    alt: 'kol-luma-event-abu-dhabi',
  },
  {
    href: 'https://luma.com/znifv3r9',
    src: '/images/singapore-luma-event.webp',
    alt: 'singapore-luma-event',
  },
  {
    href: 'https://luma.com/KOLConnect',
    src: '/images/kolconnect-synergy-summit.webp',
    alt: 'KOLConnect',
  },
];

const EventsSection = () => {
  return (
    <section data-component-id="src/app/EventsSection.tsx:26:4" data-component-path="src/app/EventsSection.tsx" data-component-line="26" data-component-end-line="55" data-component-file="EventsSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22events%22%2C%22className%22%3A%22w-full%20lg%3Apb-10%22%7D" id="events" className="w-full lg:pb-10">
      <div data-component-id="src/app/EventsSection.tsx:27:6" data-component-path="src/app/EventsSection.tsx" data-component-line="27" data-component-end-line="54" data-component-file="EventsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-%5B1440px%5D%20mx-auto%20%22%7D" className="max-w-[1440px] mx-auto ">

        {/* Title */}
        <h2 data-component-id="src/app/EventsSection.tsx:30:8" data-component-path="src/app/EventsSection.tsx" data-component-line="30" data-component-end-line="32" data-component-file="EventsSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-2xl%20sm%3Atext-3xl%20md%3Atext-4xl%20text-center%20lg%3Atext-%5B48px%5D%20font-bold%20leading-tight%20lg%3Aleading-%5B56px%5D%20text-%5B%23018440%5D%22%2C%22textContent%22%3A%22Past%20Events%22%7D" className="text-2xl sm:text-3xl md:text-4xl text-center lg:text-[48px] font-bold leading-tight lg:leading-[56px] text-[#018440]">
          Past Events
        </h2>

        {/* Event Images */}
        <div data-component-id="src/app/EventsSection.tsx:35:8" data-component-path="src/app/EventsSection.tsx" data-component-line="35" data-component-end-line="53" data-component-file="EventsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20flex%20flex-col%20sm%3Aflex-row%20justify-center%20items-center%20gap-4%20sm%3Agap-6%20mt-4%20md%3Amt-6%22%7D" className="w-full flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-6 mt-4 md:mt-6">
          {pastEvents.map((event, index) => (
            <Link data-component-id="src/app/EventsSection.tsx:37:12" data-component-path="src/app/EventsSection.tsx" data-component-line="37" data-component-end-line="51" data-component-file="EventsSection.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%7D"
              key={index}
              href={event.href}
              target="_blank"
              rel="noopener noreferrer nofollow"
            >
              <Image data-component-id="src/app/EventsSection.tsx:43:14" data-component-path="src/app/EventsSection.tsx" data-component-line="43" data-component-end-line="50" data-component-file="EventsSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22w-%5B300px%5D%20sm%3Aw-%5B330px%5D%20h-%5B300px%5D%20sm%3Ah-%5B330px%5D%20rounded-3xl%20object-contain%20hover%3Aopacity-90%20transition%22%7D"
                src={event.src}
                alt={event.alt}
                width={800}
                height={450}
                className="w-[300px] sm:w-[330px] h-[300px] sm:h-[330px] rounded-3xl object-contain hover:opacity-90 transition"
                unoptimized
              />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EventsSection;